import React from "react";
import { Tabs } from "antd";
import { withRouter } from "react-router-dom";

import { Query } from "react-apollo";
import { withApolloState } from "@arachnys/flow-app/src/util/apollo";

import queries from "../../api/queries";

import DetailTab from "./DetailTab";
import ProcessesTable from "./ProcessesTable";
import PoliciesTable from "./PoliciesTable";
import RelatedEntitiesViewer from "./RelatedEntitiesViewer";
import styles from "./styles";

const TabPane = Tabs.TabPane;

const DetailView = props => (
    <Query query={queries.ENABLED_FEATURES} fetchPolicy="cache-first">
        {withApolloState(
            ({
                data: {
                    clientConfig: { enabledFeatures },
                },
            }) => {
                const currentTab = props.match.params.tab;
                const ulid = props.match.params.ulid;

                return (
                    <div className={styles.tabs}>
                        <Tabs
                            type="card"
                            defaultActiveKey={currentTab || "details"}
                            onTabClick={key => {
                                props.history.push(`/entities/${ulid}/${key}/`);
                            }}
                        >
                            <TabPane tab="Details" key="details">
                                <DetailTab
                                    entity={props.entity}
                                    schema={props.entitySchema}
                                    canEdit={props.canEdit}
                                />
                            </TabPane>
                            <TabPane
                                tab={`Relations (${props.entity.relations.length})`}
                                key="relations"
                            >
                                <RelatedEntitiesViewer
                                    entity={props.entity}
                                    schema={props.relationSchema}
                                    relations={props.entity.relations}
                                />
                            </TabPane>
                            <TabPane
                                tab={`Research Items (${props.processes.length})`}
                                key="research-items"
                            >
                                <ProcessesTable
                                    entity={props.entity}
                                    processes={props.processes}
                                    dispatch={props.dispatch}
                                    canEdit={props.canEdit}
                                    toggleSpinner={props.toggleSpinner}
                                />
                            </TabPane>
                            {enabledFeatures.includes("POLICIES_TAB") && (
                                <TabPane
                                    tab={`Policies (${props.entity.entityPolicies.length})`}
                                    key="policies"
                                >
                                    <PoliciesTable
                                        entity={props.entity}
                                        policySchema={props.sentryPolicySchema}
                                    />
                                </TabPane>
                            )}
                        </Tabs>
                    </div>
                );
            }
        )}
    </Query>
);

export default withRouter(DetailView);
